import { render, staticRenderFns } from "./DetailData.vue?vue&type=template&id=523fcfb6&"
import script from "./DetailData.vue?vue&type=script&lang=js&"
export * from "./DetailData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports